import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    "@media(max-width: 700px)": {
      paddingLeft: 0,
    },
  },
  pivotCard: {
    paddingLeft: "2rem",
    paddingRight: "2rem",
    paddingTop: "1.5rem",
    paddingBottom: "1.5rem",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    ...shorthands.overflow("hidden"),
    backgroundColor: "#fff",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    "& .ms-Pivot": {
      ...shorthands.borderBottom("1px", "solid", "#edebe9"),
    },
  },
  cardHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "1rem",
  },
  licenseIdLabel: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#605e5c",
  },
  pivot: {
    "& .ms-Pivot-link": {
      fontSize: "1rem",
      height: "44px",
      lineHeight: "44px",
    },
    "& .ms-Pivot-link.is-selected": {
      fontWeight: 600,
    },
    "& .ms-Pivot-link .ms-Pivot-text": {
      fontSize: "1rem",
    },
  },
  tableWrap: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "calc(100vh - 260px)",
    display: "block",
    marginTop: "1rem",
    ...shorthands.border("1px", "solid", "#d9d7d5"),
    ...shorthands.borderRadius("8px"),
    "& .ms-DetailsList": {
      width: "100%",
      ...shorthands.borderRadius("8px"),
    },
    // Doubled attribute selector beats the global
    // `div[role="grid"] { height:100% !important }` rule (App.css, CF-5808) so
    // the grid sizes to its rows instead of the full wrapper height.
    "& [role='grid'][role='grid']": {
      width: "100%",
      height: "auto !important",
      maxHeight: "none",
    },
    "& .ms-DetailsHeader": {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: "#eef3fb",
      ...shorthands.borderBottom("2px", "solid", "#c7d6ea"),
      height: "56px",
      lineHeight: "56px",
    },
    "& .ms-DetailsHeader-cell": {
      height: "56px",
    },
    "& .ms-DetailsHeader-cellName": {
      fontWeight: 700,
      fontSize: "1rem",
      color: "#201f1e",
      whiteSpace: "normal",
    },
    "& .ms-DetailsRow": {
      ...shorthands.borderBottom("1px", "solid", "#e1dfdd"),
      minHeight: "60px",
    },
    "& .ms-DetailsRow:hover": {
      backgroundColor: "#f7f9fc",
    },
    '& [data-item-index="-1"]': {
      display: "none",
    },
    "& .ms-DetailsRow-cell": {
      fontSize: "1.05rem",
      paddingTop: "18px",
      paddingBottom: "18px",
      whiteSpace: "nowrap",
      ...shorthands.overflow("hidden"),
      textOverflow: "ellipsis",
      display: "flex",
      alignItems: "center",
    },
  },
});
